import { Popover, Select } from 'antd'
import useFetch from 'elements/Hooks/useFetch'
import DateCell from 'elements/Table/Cells/DateCell'
import CustomTable from 'elements/Table/CustomTable'
import { get } from 'lodash'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'

export function CustomerMaterial({ type }) {
  const { data, fetching, fetch } = useFetch({ url: `catalogs/products/${type}` })
  const [selectedType, setSelectedType] = useState(type)
  const columns = [
    {
      Header: 'ID',
      accessor: '_id',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Owner',
      accessor: 'owner.fn',
      width: 300,
    },
    {
      Header: 'Type',
      accessor: 'entryType',
      Cell: ({ original }) => {
        const isSales = !!get(original, 'enquiry._key')
        const isPurchasing = !!get(original, 'vendorQuote._key')
        if (isSales && isPurchasing) return 'SALES & PURCHASING '
        if (isSales) return 'SALES'
        if (isPurchasing) return 'PURCHASING '
        return '???'
      },
    },
    {
      Header: 'Name (i)',
      accessor: 'name',
      Cell: ({ value, original }) => (
        <Popover content={original.description}>
          <span>{value}</span>
        </Popover>
      ),
    },
    {
      Header: ' Material No (Client)',
      accessor: 'materials.no',
    },
    {
      Header: ' Vendor No (Supplier)',
      accessor: 'materials.oem.vendorNo',
    },
    {
      Header: ' Brand / OEM',
      accessor: 'materials.oem.name',
    },
    {
      Header: ' OEM No',
      accessor: 'materials.oem.no',
    },
    {
      Header: 'Date',
      accessor: 'date',
      Cell: DateCell,
    },
    {
      Header: 'Link',
      accessor: '_key',
      Cell: ({ value, original }) => {
        if (get(original, 'enquiry._key')) {
          return (
            <Link
              target={'_blank'}
              to={{
                pathname: `/clients/enquiries/${original.enquiry._key}/update`,
              }}>
              {original.enquiry.code}
            </Link>
          )
        } else if (get(original, 'vendorQuote._key'))
          return (
            <Link
              target={'_blank'}
              to={{
                pathname: `/purchasing/vendor/quotes/${original.vendorQuote._key}/update`,
              }}>
              {original.vendorQuote.quoteNo}
            </Link>
          )
      },
    },
  ]

  const filteredData = data.filter((i) => {
    if (get(i, 'enquiry._key') && selectedType === 'sales') {
      return true
    } else return !!(get(i, 'vendorQuote._key') && selectedType === 'purchasing')
  })

  return (
    <CustomTable
      isFilterable={true}
      columns={columns}
      data={selectedType === 'all' ? data : filteredData}
      fetch={fetch}
      CreateButton={() => (
        <Select defaultValue={type} style={{ width: 250 }} onChange={(t) => setSelectedType(t)}>
          <Select.Option value="all">Show All</Select.Option>
          <Select.Option value="sales">SALES</Select.Option>
          <Select.Option value="purchasing">PURCHASING</Select.Option>
        </Select>
      )}
      fetching={fetching}
    />
  )
}
